import React, {
  createContext,
  useContext,
  useState,
  useLayoutEffect,
  useRef,
} from "react";
import { SnackbarProvider } from "notistack";
import { useLocation, useNavigationType } from "react-router-dom";
import Authorization from "./Authorization";
import "./App.css";

const NightMode = createContext();
export const Nigtmode = () => useContext(NightMode);

/**
 * Centralized route scroll management.
 *
 * - PUSH: New pages begin at the top.
 * - REPLACE: New destination pages begin at the top.
 * - POP: Back/Forward restores saved positions.
 * - Hash navigation: Scrolls to the target element.
 * - Query-only changes: Preserve the current position.
 *
 * Uses instant scrolling rather than smooth animation.
 */
function ScrollManager() {
  const location = useLocation();
  const navigationType = useNavigationType();

  const savedPositions = useRef(new Map());
  const previousLocation = useRef(null);

  // Keep scroll restoration under application control.
  useLayoutEffect(() => {
    if (!("scrollRestoration" in window.history)) {
      return undefined;
    }

    const previous = window.history.scrollRestoration;
    window.history.scrollRestoration = "manual";

    return () => {
      window.history.scrollRestoration = previous;
    };
  }, []);

  // Save the current page position before leaving it.
  useLayoutEffect(() => {
    const savePosition = () => {
      const current = previousLocation.current;

      if (!current) return;

      savedPositions.current.set(current.key, {
        x: window.scrollX,
        y: window.scrollY,
      });
    };

    window.addEventListener("pagehide", savePosition);

    return () => {
      window.removeEventListener("pagehide", savePosition);
    };
  }, []);

  useLayoutEffect(() => {
    const previous = previousLocation.current;

    const samePage = previous && previous.pathname === location.pathname;

    const sameHash = previous && previous.hash === location.hash;

    const sameSearch = previous && previous.search === location.search;

    // Ignore location changes that do not affect the URL.
    if (samePage && sameHash && sameSearch) {
      previousLocation.current = location;
      return;
    }

    // Remember the page we are leaving.
    if (previous) {
      savedPositions.current.set(previous.key, {
        x: window.scrollX,
        y: window.scrollY,
      });
    }

    previousLocation.current = location;

    // Restore the previous position on Back/Forward.
    if (navigationType === "POP") {
      const saved = savedPositions.current.get(location.key);

      if (saved) {
        window.scrollTo({
          left: saved.x,
          top: saved.y,
          behavior: "instant",
        });
        return;
      }
    }

    // Handle hash links.
    if (location.hash) {
      const targetId = decodeURIComponent(location.hash.substring(1));

      const target = document.getElementById(targetId);

      if (target) {
        target.scrollIntoView({
          behavior: "instant",
          block: "start",
        });
        return;
      }
    }

    // Preserve position for query-only navigation.
    if (samePage && sameHash) {
      return;
    }

    // New route: appear at the beginning immediately.
    window.scrollTo({
      left: 0,
      top: 0,
      behavior: "instant",
    });
  }, [location, navigationType]);

  return null;
}

function App() {
  const [isnightmode, setIsnightmode] = useState(false);

  return (
    <NightMode.Provider value={{ isnightmode }}>
      <SnackbarProvider
        maxSnack={6}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <section className="App" id="universeInventoryAppId">
          <ScrollManager />
          <Authorization />
        </section>
      </SnackbarProvider>
    </NightMode.Provider>
  );
}

export default App;

// import React, { createContext, useContext, useState, useEffect } from "react";
// import { SnackbarProvider } from "notistack";
// import { useLocation } from "react-router-dom";
// import Authorization from "./Authorization";
// import "./App.css";

// const NightMode = createContext();
// export const Nigtmode = () => useContext(NightMode);

// function ScrollToTop() {
//   const { pathname } = useLocation();

//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, [pathname]);

//   return null;
// }

// function App() {
//   const [isnightmode, setIsnightmode] = useState(false);

//   return (
//     <NightMode.Provider value={{ isnightmode }}>
//       <SnackbarProvider
//         maxSnack={6}
//         anchorOrigin={{
//           vertical: "top",
//           horizontal: "right",
//         }}
//       >
//         <section className="App" id="universeInventoryAppId">
//           <Authorization />
//         </section>
//       </SnackbarProvider>
//     </NightMode.Provider>
//   );
// }

// export default App;
